module.exports = __webpack_public_path__ + "static/media/logo.5886d8fc.svg";